const MAX_DECIMALS = 2;

function normalizeDecimal(raw: string): string {
  const digits = raw.replace(/[^0-9.]/g, '');
  if (!digits) return '';

  const firstDot = digits.indexOf('.');
  if (firstDot === -1) {
    return digits;
  }

  const integerPart = digits.slice(0, firstDot);
  const decimalPart = digits
    .slice(firstDot + 1)
    .replace(/\./g, '')
    .slice(0, MAX_DECIMALS);

  if (!decimalPart) {
    return integerPart || '0';
  }

  if (!integerPart) {
    return `0.${decimalPart}`;
  }

  return `${integerPart}.${decimalPart}`;
}

/**
 * Sanitizes service price input from typing/paste.
 * Keeps only digits + a single decimal separator with up to 2 decimals.
 */
export function sanitizeServicePriceInput(value: string): string {
  return normalizeDecimal(value.trim());
}

/**
 * Normalizes a stored/raw service price to a numeric-only string.
 * Examples: "$50" -> "50", "USD 25.99" -> "25.99".
 */
export function normalizeServicePriceValue(price: string | number | null | undefined): string {
  if (price === null || price === undefined || price === '') return '';
  return sanitizeServicePriceInput(String(price));
}

/**
 * Returns a display-ready service price string with fixed "$" prefix.
 */
export function formatServicePrice(price: string | number | null | undefined): string {
  const normalized = normalizeServicePriceValue(price);
  return normalized ? `$${normalized}` : '';
}
